import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeaseWallDirective } from '@go-modules/directives/tease-wall/tease-wall.directive';
import { TeaseWallComponent } from '@go-modules/directives/tease-wall/component/tease-wall.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		TeaseWallComponent,
		TeaseWallDirective
	],
	exports: [
		TeaseWallDirective
	]
})
export class TeaseWallModule {}
